module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "height": "100%"
    },
    attrs: {
      "id": "app"
    }
  }, [_c('div', {
    directives: [{
      name: "transfer-dom",
      rawName: "v-transfer-dom"
    }],
    staticStyle: {
      "z-index": "100000"
    }
  }, [_c('loading', {
    attrs: {
      "title": "加载中..."
    },
    model: {
      value: (_vm.loading),
      callback: function($$v) {
        _vm.loading = $$v
      },
      expression: "loading"
    }
  })], 1), _vm._v(" "), _c('keep-alive', {
    attrs: {
      "include": _vm.includedComponents
    }
  }, [_c('router-view', {
    staticClass: "router-view"
  })], 1), _vm._v(" "), _c('rs-bottom', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showBottom),
      expression: "showBottom"
    }],
    attrs: {
      "slot": "bottom"
    },
    slot: "bottom"
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-40c0c38c!./~/vux-loader/src/template-loader.js!./~/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = 176
// module chunks = 41